'use strict';

import { 
  MARK_AS_VIEWED
} from '../actions';

const initialState = {
  viewed: []
};

export default function auth(state = initialState, action) {
  switch(action.type) {
  case MARK_AS_VIEWED:
    return {
      ...state,
      viewed: state.viewed.concat([action.payload]).reduce((ar, id) => ar.includes(id) ? ar : ar.concat([id]), [])
    };
  default: 
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/tasks.js